import { render, staticRenderFns } from "./uploadAttachments.vue?vue&type=template&id=04764722&scoped=true&"
import script from "./uploadAttachments.vue?vue&type=script&lang=js&"
export * from "./uploadAttachments.vue?vue&type=script&lang=js&"
import style0 from "./uploadAttachments.vue?vue&type=style&index=0&id=04764722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04764722",
  null
  
)

export default component.exports